import { toIsoDate } from './isoDate';
import { IUser } from '../interfaces/user';

const ABM = () => {};

ABM.TYPE_COLUMN = {
  STRING: 'STRING',
  NUMBER: 'NUMBER',
  BOOLEAN: 'BOOLEAN',
  DATE: 'DATE',
};

ABM.valuesResult = (set: any) => {
  const values: any = {};
  Object.keys(set).forEach((key) => {
    if (set[key] !== undefined) {
      values[key] = set[key];
    }
  });
  return values;
};

ABM.valuesResultWithFalsyValues = (columns: any, set: any) => {
  const values: any = {};
  // eslint-disable-next-line array-callback-return
  columns.map((column: any) => {
    if (column.renderFormItem && column.dataIndex) {
      if (set[column.dataIndex] && column.dataIndex !== 'id') {
        values[column.dataIndex] = set[column.dataIndex];
      } else if (column.dataIndex !== 'id') {
        if (
          (!column.formItemProps ||
            !column.formItemProps?.rules ||
            column.formItemProps?.rules?.some((item: any) => !item.required)) &&
          !column.hideInForm
        ) {
          if (column.type === ABM.TYPE_COLUMN.BOOLEAN) {
            values[column.dataIndex] = false;
          } else if (column.type === ABM.TYPE_COLUMN.NUMBER) {
            values[column.dataIndex] = undefined;
          } else {
            values[column.dataIndex] = null;
          }
        }
      }
    }
  });
  return values;
};

ABM.parseObjByConfigColumn = (
  columns: any[],
  values: any,
  notIgnoreFalsyValues?: boolean,
  // Retained for signature compatibility with existing callers. The DATE
  // branch no longer consults a timezone: a calendar date has none.
  _user?: IUser,
): any => {
  const getColumnsTypes = (): any[] => {
    const list: any[] = [];
    columns.forEach((element) => {
      if (element.type) {
        list[element.dataIndex] = element.type;
      }
    });
    return list;
  };
  const typesC: any = getColumnsTypes();
  let valuesP: any;
  if (notIgnoreFalsyValues) {
    valuesP = ABM.valuesResultWithFalsyValues(columns, values);
  } else {
    valuesP = ABM.valuesResult(values);
  }
  Object.keys(valuesP).forEach((key) => {
    switch (typesC[key]) {
      case ABM.TYPE_COLUMN.STRING:
        valuesP[key] = `${valuesP[key]}`;
        break;
      case ABM.TYPE_COLUMN.NUMBER:
        valuesP[key] = Number(valuesP[key]);
        break;
      case ABM.TYPE_COLUMN.BOOLEAN:
        if (valuesP[key] === 'false') {
          valuesP[key] = false;
        }
        if (valuesP[key] === 'true') {
          valuesP[key] = true;
        }
        break;
      case ABM.TYPE_COLUMN.DATE:
        // A calendar date, sent as the day the user picked. Two defects lived
        // on this line.
        //
        // The original produced an instant via toISOString(), baking in the
        // browser's offset and sending the previous day from any zone ahead
        // of UTC. The `.tz()` it went through was decorative: `.tz()` only
        // changes a moment's display zone, so the configured timezone never
        // reached the wire.
        //
        // The `moment(...)` wrapper that replaced it was worse in a quieter
        // way. antd is on dayjs, and `moment(aDayjs)` does not parse — it
        // returns TODAY. It only ever worked because ProForm's `dateFormatter`
        // stringifies picker values before submit; any caller without that
        // default silently replaced the user's date with the date of the edit.
        // `toIsoDate` reads a string, a Date, a Dayjs or a moment directly.
        valuesP[key] = toIsoDate(valuesP[key]);
        break;
      default:
        break;
    }
  });
  return valuesP;
};

export { ABM };
